module.exports = __webpack_public_path__ + "static/media/img-TarjetaHazteSocio.34d578bb.png";